<h3></h3>
<div class="sticky-table-left">
    <div class="year-selector">
        <button [disabled]="disabledPrevButton" (click)="changeDate('prev')">
            <mat-icon>keyboard_arrow_left</mat-icon>
        </button>
        <input matInput [formControl]="yearControl" readonly>
        <button [disabled]="disabledNextButton" (click)="changeDate('next')">
            <mat-icon>keyboard_arrow_right</mat-icon>
        </button>
    </div>
    <div class="comm-table comm-table-attibu inner-table">
        <table>
            <thead class="sticky-header">
                <tr>
                    <th></th>
                    <th>Ene</th>
                    <th>Feb</th>
                    <th>Mar</th>
                    <th>Abr</th>
                    <th>May</th>
                    <th>Jun</th>
                    <th>Jul</th>
                    <th>Ago</th>
                    <th>Sep</th>
                    <th>Oct</th>
                    <th>Nov</th>
                    <th>Dic</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let staff of staffAttributeCount; let i = index">
                    <th>{{staff.atributo}}</th>
                    <td>
                        <mat-form-field class="example-full-width">
                            <input matInput min="0" pattern="[0-9]+" 
                                [disabled]="!isCompanyActive" 
                                oninput="this.value = !!this.value && Math.abs(this.value) >= 0 ? Math.abs(this.value) : null"
                                (click)="getIntialCellValue($event.target.value,this.selectedAttributeData.empresaId,this.yearControl.value,1,staff.atributo,this.selectedTipo)"
                                (keyup.Tab)="getIntialCellValue($event.target.value,this.selectedAttributeData.empresaId,this.yearControl.value,1,staff.atributo,this.selectedTipo)"
                                (blur)="updateCell($event.target.value,staff.atributo,1)"
                                (keyup.enter)="onEnterUpdateCell($event.target.value,staff.atributo,1)"
                                (keydown.enter)="onEnterUpdateCell($event.target.value,staff.atributo,1)"
                                [value]="staff.jan">
                        </mat-form-field>
                    </td>
                    <td>
                        <mat-form-field class="example-full-width">
                            <input matInput min="0" pattern="[0-9]+" 
                                [disabled]="!isCompanyActive" 
                                oninput="this.value = !!this.value && Math.abs(this.value) >= 0 ? Math.abs(this.value) : null"
                                (click)="getIntialCellValue($event.target.value,this.selectedAttributeData.empresaId,this.yearControl.value,2,staff.atributo,this.selectedTipo)"
                                (keyup.Tab)="getIntialCellValue($event.target.value,this.selectedAttributeData.empresaId,this.yearControl.value,2,staff.atributo,this.selectedTipo)"
                                (blur)="updateCell($event.target.value,staff.atributo,2)"
                                (keyup.enter)="onEnterUpdateCell($event.target.value,staff.atributo,2)"
                                (keydown.enter)="onEnterUpdateCell($event.target.value,staff.atributo,2)"
                                [value]="staff.feb">
                        </mat-form-field>
                    </td>
                    <td>
                        <mat-form-field class="example-full-width">
                            <input matInput min="0" pattern="[0-9]+" 
                                [disabled]="!isCompanyActive" 
                                oninput="this.value = !!this.value && Math.abs(this.value) >= 0 ? Math.abs(this.value) : null"
                                (click)="getIntialCellValue($event.target.value,this.selectedAttributeData.empresaId,this.yearControl.value,3,staff.atributo,this.selectedTipo)"
                                (keyup.Tab)="getIntialCellValue($event.target.value,this.selectedAttributeData.empresaId,this.yearControl.value,3,staff.atributo,this.selectedTipo)"
                                (blur)="updateCell($event.target.value,staff.atributo,3)"
                                (keyup.enter)="onEnterUpdateCell($event.target.value,staff.atributo,3)"
                                (keydown.enter)="onEnterUpdateCell($event.target.value,staff.atributo,3)"
                                [value]="staff.mar">
                        </mat-form-field>
                    </td>
                    <td>
                        <mat-form-field class="example-full-width">
                            <input matInput min="0" pattern="[0-9]+"
                                [disabled]="!isCompanyActive" 
                                oninput="this.value = !!this.value && Math.abs(this.value) >= 0 ? Math.abs(this.value) : null"
                                (click)="getIntialCellValue($event.target.value,this.selectedAttributeData.empresaId,this.yearControl.value,4,staff.atributo,this.selectedTipo)"
                                (keyup.Tab)="getIntialCellValue($event.target.value,this.selectedAttributeData.empresaId,this.yearControl.value,4,staff.atributo,this.selectedTipo)"
                                (blur)="updateCell($event.target.value,staff.atributo,4)"
                                (keyup.enter)="onEnterUpdateCell($event.target.value,staff.atributo,4)"
                                (keydown.enter)="onEnterUpdateCell($event.target.value,staff.atributo,4)"
                                [value]="staff.apr">
                        </mat-form-field>
                    </td>
                    <td>
                        <mat-form-field class="example-full-width">
                            <input matInput min="0" pattern="[0-9]+" 
                                [disabled]="!isCompanyActive" 
                                oninput="this.value = !!this.value && Math.abs(this.value) >= 0 ? Math.abs(this.value) : null"
                                (click)="getIntialCellValue($event.target.value,this.selectedAttributeData.empresaId,this.yearControl.value,5,staff.atributo,this.selectedTipo)"
                                (keyup.Tab)="getIntialCellValue($event.target.value,this.selectedAttributeData.empresaId,this.yearControl.value,5,staff.atributo,this.selectedTipo)"
                                (blur)="updateCell($event.target.value,staff.atributo,5)"
                                (keyup.enter)="onEnterUpdateCell($event.target.value,staff.atributo,5)"
                                (keydown.enter)="onEnterUpdateCell($event.target.value,staff.atributo,5)"
                                [value]="staff.may">
                        </mat-form-field>
                    </td>
                    <td>
                        <mat-form-field class="example-full-width">
                            <input matInput min="0" pattern="[0-9]+"    
                                [disabled]="!isCompanyActive" 
                                oninput="this.value = !!this.value && Math.abs(this.value) >= 0 ? Math.abs(this.value) : null"
                                (click)="getIntialCellValue($event.target.value,this.selectedAttributeData.empresaId,this.yearControl.value,6,staff.atributo,this.selectedTipo)"
                                (keyup.Tab)="getIntialCellValue($event.target.value,this.selectedAttributeData.empresaId,this.yearControl.value,6,staff.atributo,this.selectedTipo)"
                                (blur)="updateCell($event.target.value,staff.atributo,6)"
                                (keyup.enter)="onEnterUpdateCell($event.target.value,staff.atributo,6)"
                                (keydown.enter)="onEnterUpdateCell($event.target.value,staff.atributo,6)"
                                [value]="staff.jun">
                        </mat-form-field>
                    </td>
                    <td>
                        <mat-form-field class="example-full-width">
                            <input matInput min="0" pattern="[0-9]+"
                                [disabled]="!isCompanyActive" 
                                oninput="this.value = !!this.value && Math.abs(this.value) >= 0 ? Math.abs(this.value) : null"
                                (click)="getIntialCellValue($event.target.value,this.selectedAttributeData.empresaId,this.yearControl.value,7,staff.atributo,this.selectedTipo)"
                                (keyup.Tab)="getIntialCellValue($event.target.value,this.selectedAttributeData.empresaId,this.yearControl.value,7,staff.atributo,this.selectedTipo)"
                                (blur)="updateCell($event.target.value,staff.atributo,7)"
                                (keyup.enter)="onEnterUpdateCell($event.target.value,staff.atributo,7)"
                                (keydown.enter)="onEnterUpdateCell($event.target.value,staff.atributo,7)"
                                [value]="staff.jul">
                        </mat-form-field>
                    </td>
                    <td>
                        <mat-form-field class="example-full-width">
                            <input matInput min="0" pattern="[0-9]+"
                                [disabled]="!isCompanyActive" 
                                oninput="this.value = !!this.value && Math.abs(this.value) >= 0 ? Math.abs(this.value) : null"
                                (click)="getIntialCellValue($event.target.value,this.selectedAttributeData.empresaId,this.yearControl.value,8,staff.atributo,this.selectedTipo)"
                                (keyup.Tab)="getIntialCellValue($event.target.value,this.selectedAttributeData.empresaId,this.yearControl.value,8,staff.atributo,this.selectedTipo)"
                                (blur)="updateCell($event.target.value,staff.atributo,8)"
                                (keyup.enter)="onEnterUpdateCell($event.target.value,staff.atributo,8)"
                                (keydown.enter)="onEnterUpdateCell($event.target.value,staff.atributo,8)"
                                [value]="staff.aug">
                        </mat-form-field>
                    </td>
                    <td>
                        <mat-form-field class="example-full-width">
                            <input matInput min="0" pattern="[0-9]+"    
                                [disabled]="!isCompanyActive" 
                                oninput="this.value = !!this.value && Math.abs(this.value) >= 0 ? Math.abs(this.value) : null"
                                (click)="getIntialCellValue($event.target.value,this.selectedAttributeData.empresaId,this.yearControl.value,9,staff.atributo,this.selectedTipo)"
                                (keyup.Tab)="getIntialCellValue($event.target.value,this.selectedAttributeData.empresaId,this.yearControl.value,9,staff.atributo,this.selectedTipo)"
                                (blur)="updateCell($event.target.value,staff.atributo,9)"
                                (keyup.enter)="onEnterUpdateCell($event.target.value,staff.atributo,9)"
                                (keydown.enter)="onEnterUpdateCell($event.target.value,staff.atributo,9)"
                                [value]="staff.sep">
                        </mat-form-field>
                    </td>
                    <td>
                        <mat-form-field class="example-full-width">
                            <input matInput min="0" pattern="[0-9]+"    
                                [disabled]="!isCompanyActive" 
                                oninput="this.value = !!this.value && Math.abs(this.value) >= 0 ? Math.abs(this.value) : null"
                                (click)="getIntialCellValue($event.target.value,this.selectedAttributeData.empresaId,this.yearControl.value,10,staff.atributo,this.selectedTipo)"
                                (keyup.Tab)="getIntialCellValue($event.target.value,this.selectedAttributeData.empresaId,this.yearControl.value,10,staff.atributo,this.selectedTipo)"
                                (blur)="updateCell($event.target.value,staff.atributo,10)"
                                (keyup.enter)="onEnterUpdateCell($event.target.value,staff.atributo,10)"
                                (keydown.enter)="onEnterUpdateCell($event.target.value,staff.atributo,10)"
                                [value]="staff.oct">
                        </mat-form-field>
                    </td>
                    <td>
                        <mat-form-field class="example-full-width">
                            <input matInput min="0" pattern="[0-9]+"
                                [disabled]="!isCompanyActive" 
                                oninput="this.value = !!this.value && Math.abs(this.value) >= 0 ? Math.abs(this.value) : null"
                                (click)="getIntialCellValue($event.target.value,this.selectedAttributeData.empresaId,this.yearControl.value,11,staff.atributo,this.selectedTipo)"
                                (keyup.Tab)="getIntialCellValue($event.target.value,this.selectedAttributeData.empresaId,this.yearControl.value,11,staff.atributo,this.selectedTipo)"
                                (blur)="updateCell($event.target.value,staff.atributo,11)"
                                (keyup.enter)="onEnterUpdateCell($event.target.value,staff.atributo,11)"
                                (keydown.enter)="onEnterUpdateCell($event.target.value,staff.atributo,11)"
                                [value]="staff.nov">
                        </mat-form-field>
                    </td>
                    <td>
                        <mat-form-field class="example-full-width">
                            <input matInput min="0" pattern="[0-9]+"
                                [disabled]="!isCompanyActive" 
                                oninput="this.value = !!this.value && Math.abs(this.value) >= 0 ? Math.abs(this.value) : null"
                                (click)="getIntialCellValue($event.target.value,this.selectedAttributeData.empresaId,this.yearControl.value,12,staff.atributo,this.selectedTipo)"
                                (keyup.Tab)="getIntialCellValue($event.target.value,this.selectedAttributeData.empresaId,this.yearControl.value,12,staff.atributo,this.selectedTipo)"
                                (blur)="updateCell($event.target.value,staff.atributo,12)"
                                (keyup.enter)="onEnterUpdateCell($event.target.value,staff.atributo,12)"
                                (keydown.enter)="onEnterUpdateCell($event.target.value,staff.atributo,12)"
                                [value]="staff.dec">
                        </mat-form-field>
                    </td>
                </tr>
                <tr *ngFor="let staff of staffAttributeCountTotal; let i = index">
                    <th>{{staff.atributo}}</th>
                    <td>
                        <mat-form-field class="example-full-width">
                            <input matInput [value]="staff.jan" disabled>
                        </mat-form-field>
                    </td>
                    <td>
                        <mat-form-field class="example-full-width">
                            <input matInput [value]="staff.feb" disabled>
                        </mat-form-field>
                    </td>
                    <td>
                        <mat-form-field class="example-full-width">
                            <input matInput [value]="staff.mar" disabled>
                        </mat-form-field>
                    </td>
                    <td>
                        <mat-form-field class="example-full-width">
                            <input matInput [value]="staff.apr" disabled>
                        </mat-form-field>
                    </td>
                    <td>
                        <mat-form-field class="example-full-width">
                            <input matInput [value]="staff.may" disabled>
                        </mat-form-field>
                    </td>
                    <td>
                        <mat-form-field class="example-full-width">
                            <input matInput [value]="staff.jun" disabled>
                        </mat-form-field>
                    </td>
                    <td>
                        <mat-form-field class="example-full-width">
                            <input matInput [value]="staff.jul" disabled>
                        </mat-form-field>
                    </td>
                    <td>
                        <mat-form-field class="example-full-width">
                            <input matInput [value]="staff.aug" disabled>
                        </mat-form-field>
                    </td>
                    <td>
                        <mat-form-field class="example-full-width">
                            <input matInput [value]="staff.sep" disabled>
                        </mat-form-field>
                    </td>
                    <td>
                        <mat-form-field class="example-full-width">
                            <input matInput [value]="staff.oct" disabled>
                        </mat-form-field>
                    </td>
                    <td>
                        <mat-form-field class="example-full-width">
                            <input matInput [value]="staff.nov" disabled>
                        </mat-form-field>
                    </td>
                    <td>
                        <mat-form-field class="example-full-width">
                            <input matInput [value]="staff.dec" disabled>
                        </mat-form-field>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>